import { Link } from "react-router-dom";
import type { Question, VoteRecord } from "../lib/types";

export default function QuestionCard({
  question,
  vote,
}: {
  question: Question;
  vote?: VoteRecord;
}) {
  return (
    <Link
      to={`/questions/${question.id}`}
      className="card hover:border-cedar transition no-underline block"
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs uppercase tracking-wider text-muted">
          {question.id}
        </span>
        {vote ? (
          <span className="text-xs text-cedar">
            voted ({vote.optionKey})
          </span>
        ) : (
          <span className="text-xs text-muted">not yet voted</span>
        )}
      </div>
      <h3 className="text-base font-medium text-ink mb-1">{question.title}</h3>
      <p className="text-sm text-muted line-clamp-2">{question.context}</p>
    </Link>
  );
}
